import { StateSchema } from 'app/config/storeConfig/types';
import { RequestFormModalSchema } from '../types';

export const getModalState = (state: StateSchema): RequestFormModalSchema => state.requestFormModal;
